const BASE = '/api';
const getToken = () => localStorage.getItem('token');

export const api = async (path, options = {}) => {
  const res = await fetch(`${BASE}${path}`, {
    ...options,
    headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${getToken()}`, ...(options.headers||{}) },
    body: options.body ? JSON.stringify(options.body) : undefined
  });
  if (res.status === 401) { localStorage.removeItem('token'); window.location.href = '/login'; return; }
  if (!res.ok) { const e = await res.json().catch(()=>({})); throw new Error(e.error || 'Ошибка сервера'); }
  return res.json();
};

export const get = p => api(p);
export const post = (p, body) => api(p, { method:'POST', body });
export const put = (p, body) => api(p, { method:'PUT', body });
export const del = p => api(p, { method:'DELETE' });

export const downloadFile = async (path, filename) => {
  const res = await fetch(`${BASE}${path}`, { headers:{ Authorization:`Bearer ${getToken()}` } });
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a'); a.href=url; a.download=filename; a.click();
  URL.revokeObjectURL(url);
};
